import { api } from "./BackendService";

export const create = (data) => api.post("/agents", data);
export const edit = (id, data) => api.put(`/agents/${id}`, data);
export const getById = (id) => api.get(`/agents/${id}`);
export const list = (page) => api.get("/agents", { params: { page: page } });

export const listThreads = (id, page) =>
  api.get(`/agents/${id}/threads`, { params: { page: page } });

export const listThreadMessages = (id, threadId, page) =>
  api.get(`/agents/${id}/threads/${threadId}/messages`, {
    params: { page: page },
  });
